import { inject, Injectable } from '@angular/core';
import { ACCESS_API } from '../api/access-api.token';
import { AttentionModel, TreeModel } from '../models/access.models';

/** The tree is read whole (413 nodes, ~100 KB); the page, the selects of the node and the form of the stores share one copy until something changes. */
@Injectable({ providedIn: 'root' })
export class AccessDataService {
  private readonly api = inject(ACCESS_API);
  private treeRequest: Promise<TreeModel> | null = null;

  tree(force = false): Promise<TreeModel> {
    if (force || this.treeRequest === null) {
      const request = this.api.getTree();
      this.treeRequest = request;
      request.catch(() => {
        if (this.treeRequest === request) {
          this.treeRequest = null;
        }
      });
    }
    return this.treeRequest;
  }

  invalidate(): void {
    this.treeRequest = null;
  }

  attention(): Promise<AttentionModel> {
    return this.api.getAttention();
  }
}
